import React from "react";
import { Check } from "lucide-react";
import { motion } from "framer-motion";

const ProgressBar = ({ currentStep }) => {
  const steps = [
    { number: 1, label: "Location" },
    { number: 2, label: "Account" },
    { number: 3, label: "Review" },
    { number: 4, label: "Payment" },
  ];

  return (
    <div className="bg-[#111111] border border-white/[0.08] rounded-2xl p-4 sm:p-5">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="flex flex-col items-center flex-1">
              <motion.div
                animate={
                  currentStep > step.number
                    ? { scale: 1, backgroundColor: "#FF6B35" }
                    : currentStep === step.number
                    ? { scale: 1.1, backgroundColor: "#FF6B35" }
                    : { scale: 1, backgroundColor: "rgba(255,255,255,0.08)" }
                }
                transition={{ duration: 0.3 }}
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center font-bold text-sm"
              >
                {currentStep > step.number ? (
                  <Check className="h-5 w-5 text-white" />
                ) : (
                  <span className={currentStep >= step.number ? "text-white" : "text-gray-500"}>
                    {step.number}
                  </span>
                )}
              </motion.div>
              <p
                className={`mt-2 text-xs font-semibold text-center ${
                  currentStep >= step.number ? "text-[#FF6B35]" : "text-gray-600"
                }`}
              >
                {step.label}
              </p>
            </div>

            {index < steps.length - 1 && (
              <div className="flex-1 h-0.5 mx-2 sm:mx-3 mb-6">
                <motion.div
                  animate={{ scaleX: currentStep > step.number ? 1 : 0 }}
                  initial={{ scaleX: 0 }}
                  style={{ originX: 0 }}
                  transition={{ duration: 0.4 }}
                  className="h-full bg-[#FF6B35] rounded-full"
                />
                <div
                  className={`h-full rounded-full -mt-0.5 ${
                    currentStep > step.number ? "bg-transparent" : "bg-white/[0.08]"
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
